import { atom, map } from "nanostores";

export const $surveySectionQuestions = map<{ [key: string]: string }>({});
export const $popupContent = atom<string>("");
